<template>
  <div data-samora>
    <p>Hello world</p>
  </div>
</template>

<script>
export default {
  name: 'SamGuide',
};
</script>

<style lang="scss" scoped></style>
